<template>
    <div ref="pageTerms" class="page-terms m-y-50">
        <UContainer class="sm:max-w-[540px] md:max-w-[720px] lg:max-w-[812px] px-4!">
            <div class="flex justify-center">
                <article class="wrapper w-full markdown-body">
                    <ContentRenderer v-if="terms" :value="terms" />
                    <p v-else class="font-manrope text-[#212529] self-center text-center my-10!">Loading terms...</p>
                </article>
            </div>
        </UContainer>
    </div>
</template>

<script setup lang="ts">
import { breadcrumb, termsSchemas } from '~/scripts/utils/constants/structured-data/index'

definePageMeta({
    layout: 'default',
})

const { data: terms, refresh: refreshTerms } = await useAsyncData(
    'terms',
    async () => {
        console.log('terms')
        const x = queryCollection('content')
        const path = x.path('/terms/terms')
        const first = await path.first()
        console.log(x, 'x')
        console.log(path, 'path')
        console.log(first, 'first')
        return first
    }
)

onMounted(() => {
    if (!terms.value) {
        refreshTerms()
    }
})

useHead({
    title: 'Terms and Conditions | Peekage: Product Sampling Platform',
    meta: [
        {
            name: 'description',
            content: "These terms and conditions help define Peekage's relationship with you as you interact with our services. Contact us for any questions.",
        },
    ],
    link: [
        {
            rel: 'canonical',
            href: 'https://peekage.com/terms',
        },
    ],
    script: [
        {
            type: 'application/ld+json',
            children: JSON.stringify(breadcrumb({
                name: 'Terms & Conditions',
                uri: '/terms',
            })),
        },
        ...termsSchemas.map((schema) => ({
            type: 'application/ld+json',
            children: JSON.stringify(schema),
        })),
    ],
})
</script>

<style lang="scss" scoped>
.page-terms {
    position: relative;
    @media only screen and (max-width: 600px) {
        .primary {
            right: 20px;
            bottom: 30px;
        }
    }
}

article {
    color: #212529;
}

.markdown-body {
    font-family: var(--font-manrope), sans-serif;
    color: #212529;
    line-height: 1.75;

    :deep(h1) {
        font-size: 1.75rem;
        font-weight: 700;
        margin-top: 0;
        margin-bottom: 1rem;
        color: #212529;
    }
    :deep(h2) {
        font-size: 1.25rem;
        font-weight: 700;
        margin-top: 2rem;
        margin-bottom: 0.75rem;
        color: #212529;
        border-bottom: 1px solid #e5e7eb;
        padding-bottom: 0.5rem;
    }
    :deep(h3) {
        font-size: 1.125rem;
        font-weight: 600;
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
        color: #212529;
    }
    :deep(h4) {
        font-size: 1rem;
        font-weight: 600;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
        color: #212529;
    }
    :deep(p) {
        margin-bottom: 1rem;
        color: #212529;
    }
    :deep(ul) {
        list-style-position: outside;
        padding-left: 2.5rem;
        margin-bottom: 1rem;
        color: #212529;
    }
    :deep(ol) {
        list-style-type: decimal;
        padding-left: 2.5rem;
        margin-bottom: 1rem;
        color: #212529;
    }
    :deep(li) {
        margin-bottom: 0.25rem;
        color: #212529;
    }
    :deep(strong) {
        font-weight: 600;
        color: #212529;
    }
    :deep(hr) {
        margin: 2rem 0;
        border: 0;
        border-top: 1px solid #e5e7eb;
    }
    :deep(blockquote) {
        border-left: 4px solid #d1d5db;
        padding-left: 1rem;
        font-style: italic;
        color: #212529;
        margin: 1rem 0;
    }
    :deep(a) {
        color: #212529;
        text-decoration: none;
    }
    :deep(a:hover) {
        text-decoration: underline;
    }
}
</style>
